import React from 'react'

import HeaderTopBar from './components/HeaderTopBar/HeaderTopBar.component'
import HeaderNavBar from './components/HeaderNavBar/HeaderNavBar.component'
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs.components'
import AgentSearch from './components/AgentSearch/AgentSearch.component'
import FooterContent from './components/FooterContent/FooterContent.component'
import FooterDisclaimer from './components/FooterDisclaimer/FooterDisclaimer.component'

import './OurLicensedAgents.page.scss'

class OurLicensedAgentsPage extends React.Component {
  componentDidMount() {
    document.title = 'Our Licensed Agents | Health Insurance Agency | USA Benefits Group'
  }

  render() {
    return (
      <div id='OurLicensedAgentsPage'>
        <HeaderTopBar />
        <HeaderNavBar />
        <Breadcrumbs
          items={[{ label: 'Home', href: '/' }, { label: 'Why USA Benefits Group' }, { label: 'Our Licensed Agents' }]}
        />
        <AgentSearch />
        <FooterContent />
        <FooterDisclaimer />
      </div>
    )
  }
}

export default OurLicensedAgentsPage
